(function () {
    'use strict';

    angular
        .module('riskEditModule', [
            'services.authenticatedUser',
            'governanceProcessModule',
            'actionPlanModule',
            'services.historyCtxt',
            'riskModule',
            'boxTemplateModule'
        ]);
})();
